import React from 'react';
import { ApolloProvider as HooksProvider } from '@apollo/react-hooks';
import { /* apolloCacheService, */ apolloService } from '../services';

/* -------------------------------------------------------------------------- *
 * ApolloProvider
 *
 * Powers Apollo hooks throughout the application.
 * -------------------------------------------------------------------------- */
export const ApolloProvider = ( { children } ) => {
    // TODO: Revisit restoring Apollo's cache when landing on site?

    return (
        <HooksProvider client={ apolloService } children={ children } />
    );
};
